(() => {
  async function sortCollection(root) {
    if (root.dataset.sort !== 'created-descending' || root.dataset.newestReady) return;
    root.dataset.newestReady = 'true';
    const grid = root.querySelector('[data-wm-product-grid]');
    const pagination = root.querySelector('.wm-pagination');
    const status = document.createElement('p');
    status.className = 'wm-collection__sort-status';
    status.setAttribute('role', 'status');
    status.textContent = 'Sorting newest arrivals…';
    grid.before(status);
    grid.style.setProperty('display', 'none');
    grid.setAttribute('aria-busy', 'true');
    if (pagination) pagination.style.setProperty('display', 'none');

    async function fetchResponse(url) {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
      return response;
    }

    try {
      // Fetch every filtered page before sorting, so priority applies across pages.
      const cards = new Map();
      const collect = (element) => {
        element.querySelectorAll('[data-wm-product-grid] > [data-product-id]').forEach(card => {
          cards.set(card.dataset.productId, card);
        });
      };
      collect(root);
      const loadCards = async () => {
        for (let page = 1; page <= Number(root.dataset.pages); page++) {
          if (page === Number(root.dataset.page)) continue;
          const url = new URL(window.location.href);
          url.searchParams.set('page', page);
          url.searchParams.set('section_id', root.dataset.sectionId);
          const response = await fetchResponse(url);
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = document.querySelector('[data-wm-collection]');
          if (!section) throw new Error('Collection section missing');
          collect(section);
        }
      };
      // Liquid does not expose product edit timestamps; use the storefront feed.
      const metadata = new Map();
      const loadMetadata = async () => {
        for (let page = 1; ; page++) {
          const url = new URL(`${root.dataset.collectionUrl}/products.json`, window.location.origin);
          url.searchParams.set('limit', '250');
          url.searchParams.set('page', page);
          const response = await fetchResponse(url);
          const { products } = await response.json();
          if (!Array.isArray(products)) throw new Error('Product metadata missing');
          for (const product of products) {
            const updated = Date.parse(product.updated_at);
            if (!Number.isFinite(updated)) throw new Error('Product edit timestamp missing');
            const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(tag => tag.trim());
            metadata.set(String(product.id), { isNew: tags.includes('New'), updated });
          }
          if (products.length < 250) break;
        }
      };
      await Promise.all([loadCards(), loadMetadata()]);
      const sorted = Array.from(cards.values());
      if (sorted.some(card => !metadata.has(card.dataset.productId))) throw new Error('Incomplete product metadata');
      sorted.sort((a, b) => {
        const first = metadata.get(a.dataset.productId);
        const second = metadata.get(b.dataset.productId);
        return Number(second.isNew) - Number(first.isNew) || second.updated - first.updated || a.dataset.productId.localeCompare(b.dataset.productId);
      });
      const size = Number(root.dataset.pageSize);
      const pages = Math.ceil(sorted.length / size);
      const page = Math.min(Number(root.dataset.page), Math.max(pages, 1));
      if (sorted.length) grid.replaceChildren(...sorted.slice((page - 1) * size, page * size));
      root.querySelector('.wm-collection__toolbar-meta').textContent = `${sorted.length} items`;
      if (pagination) pagination.remove();
      if (pages > 1) {
        const nav = document.createElement('nav');
        nav.className = 'wm-pagination';
        nav.setAttribute('aria-label', 'Pagination');
        for (let index = 1; index <= pages; index++) {
          const item = document.createElement(index === page ? 'span' : 'a');
          item.textContent = index;
          if (index === page) {
            item.className = 'is-current';
            item.setAttribute('aria-current', 'page');
          } else {
            const url = new URL(window.location.href);
            url.searchParams.set('page', index);
            item.href = url.toString();
          }
          nav.append(item);
        }
        root.append(nav);
      }
      status.remove();
    } catch (error) {
      status.textContent = 'Newest arrivals could not be sorted. Please reload to try again.';
      if (pagination) pagination.style.removeProperty('display');
      console.error('Newest arrivals sorting failed', error);
    } finally {
      grid.style.removeProperty('display');
      grid.removeAttribute('aria-busy');
    }
  }

  document.querySelectorAll('[data-wm-collection]').forEach(sortCollection);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-wm-collection]').forEach(sortCollection);
  });
})();
